import React from 'react';
import { Link } from 'react-router-dom';

/**
 * CTASection — Full-width call-to-action band
 * variants: 'dark' | 'deep' | 'light'
 */
export default function CTASection({
  eyebrow,
  headline,
  subtext,
  primaryCTA,
  secondaryCTA,
  variant = 'dark',
}) {
  const sectionClass =
    variant === 'deep'
      ? 'cta-band cta-band--deep'
      : variant === 'light'
        ? 'cta-band section--alt section--rule'
        : 'cta-band cta-band--dark';

  const headlineColor =
    variant === 'light' ? 'var(--navy-800)' : 'var(--white)';

  const subtextColor =
    variant === 'light' ? 'var(--gray-600)' : 'rgba(255,255,255,0.62)';

  const outlineClass =
    variant === 'light' ? 'btn-outline-navy' : 'btn-outline-light';

  return (
    <section className={sectionClass}>
      <div className="container">
        {eyebrow && (
          <div className="eyebrow eyebrow--center eyebrow--light mb-4">
            {eyebrow}
          </div>
        )}

        <h2
          className="d-lg text-center"
          style={{ color: headlineColor, maxWidth: '700px', margin: '0 auto' }}
        >
          {headline}
        </h2>

        {subtext && (
          <p
            className="lead text-center"
            style={{
              maxWidth: '520px',
              margin: 'var(--sp-5) auto 0',
              color: subtextColor,
            }}
          >
            {subtext}
          </p>
        )}

        <div className="cta-band__actions">
          {primaryCTA && (
            <Link to={primaryCTA.to} className="btn btn-primary">
              {primaryCTA.label}
            </Link>
          )}
          {secondaryCTA && (
            <Link to={secondaryCTA.to} className={`btn ${outlineClass}`}>
              {secondaryCTA.label}
            </Link>
          )}
        </div>
      </div>
    </section>
  );
}
